<template>
  <div>
    <!-- Listado Expedientes -->
    <v-card v-if="bottomNav === 0" class="hide-overflow">
      <v-toolbar flat color="white">
        <v-toolbar-title>Expedientes</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-text-field
          v-model="searchExpediente"
          append-icon="search"
          label="Buscar"
          single-line
          hide-details
        >
        </v-text-field>
        <v-spacer></v-spacer>
        <!-- Nuevo Expediente -->
        <!-- <v-btn color="primary" dark class="mb-2" @click="creteNewExpediente">Nuevo Expediente</v-btn> -->
        <new-expediente></new-expediente>
      </v-toolbar>
      <v-divider class="mx-2"></v-divider>
      <v-card-text>
        <v-dialog v-model="expteFilteredDialog" max-width="500px">
          <v-btn slot="activator" color="primary" dark class="mb-2">
            Filtros
          </v-btn>
          <v-card>
            <v-card-title>
              <div>
                <div class="headline">Configurar Filtros</div>
                <span class="grey--text"
                  >{{ expedientesFilter.length }} Registros coincidentes</span
                >
              </div>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-combobox
                      v-model="expedientesFilterOption.provincia"
                      :items="expedientesFilterProvincias"
                      label="Provincia"
                      multiple
                    >
                    </v-combobox>
                  </v-flex>
                  <v-flex xs12>
                    <v-combobox
                      v-model="expedientesFilterOption.gestor"
                      :items="expedientesFilterGestor"
                      label="Gestor"
                      multiple
                    >
                    </v-combobox>
                  </v-flex>
                  <v-flex xs12>
                    <v-combobox
                      v-model="expedientesFilterOption.admon"
                      :items="expedientesFilterAdmon"
                      label="Administrador"
                      multiple
                    >
                    </v-combobox>
                  </v-flex>
                  <v-flex xs12>
                    <v-combobox
                      v-model="expedientesFilterOption.status"
                      :items="expedientesFilterStatus"
                      label="Estado"
                      multiple
                    >
                    </v-combobox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                flat
                @click.native="expteFilteredDialog = false"
                >Cerrar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn
          fab
          dark
          small
          :color="expteFilteredList ? 'success' : 'secondary'"
          @click="expteFilteredList = !expteFilteredList"
          ><v-icon>filter_list</v-icon></v-btn
        >
        <v-chip
          :color="expteFilteredList ? 'green lighten-3' : 'grey lighten-3'"
        >
          <v-avatar
            :class="expteFilteredList ? 'success' : 'secondary'"
            class="white--text"
            >{{ expedientesFiltersAplicados.length }}</v-avatar
          >
          <span>Filtros Aplicados</span>
        </v-chip>
        <div class="text-xs-center" v-if="expteFilteredList">
          <v-chip
            @input="removeExpteFilter(item, 'provincia')"
            close
            color="teal accent-1"
            v-for="(item, key) in expedientesFilterOption.provincia"
            :key="key"
            ><v-avatar class="teal">P</v-avatar>{{ item }}</v-chip
          >
          <v-chip
            @input="removeExpteFilter(item, 'gestor')"
            close
            color="purple accent-1"
            v-for="(item, key) in expedientesFilterOption.gestor"
            :key="key + 100"
            ><v-avatar class="purple">G</v-avatar>{{ item }}</v-chip
          >
          <v-chip
            @input="removeExpteFilter(item, 'admon')"
            close
            color="lime accent-1"
            v-for="(item, key) in expedientesFilterOption.admon"
            :key="key + 200"
            ><v-avatar class="lime">A</v-avatar>{{ item }}</v-chip
          >
          <v-chip
            @input="removeExpteFilter(item, 'status')"
            close
            color="red accent-1"
            v-for="(item, key) in expedientesFilterOption.status"
            :key="key + 300"
            ><v-avatar class="red">E</v-avatar>{{ item }}</v-chip
          >
        </div>
      </v-card-text>
      <v-data-table
        rows-per-page-text="Resultados por página"
        :headers="expedientesControl.headers"
        :items="expedientesFilter"
        :search="searchExpediente"
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <td>
            <a
              v-if="props.item.idx"
              class="btn btn-outline-primary btn-sm no-decoration"
              role="button"
              @click="desactivarExpediente(props.item.idx)"
            >
              <v-icon class="mr-2" color="red">delete_sweep</v-icon>
            </a>
            {{ expteId(props.item.idx) }}
          </td>
          <td>{{ props.item.detalle.provincia || "-" }}</td>
          <td>{{ gestoresObject[props.item.detalle.gestor] || "-" }}</td>
          <td>{{ props.item.detalle.fecha }}</td>
          <td>{{ adminfincasObject[props.item.detalle.admon] || "-" }}</td>
          <td>{{ props.item.detalle.status }}</td>
          <td class="text-xs-right">
            <a
              v-if="props.item.idx"
              class="btn btn-outline-primary btn-sm no-decoration"
              role="button"
              @click="editarExpediente(props.item.idx)"
            >
              <v-icon class="mr-2" color="primary">create</v-icon>
            </a>
          </td>
        </template>
        <template slot="no-data">
          <v-alert :value="true" color="info" icon="info">
            No existen documentos :(
          </v-alert>
        </template>
      </v-data-table>
    </v-card>
    <!-- Perfil Usuario -->
    <!-- <v-card v-if="bottomNav === 2 || bottomNav === 4" class="hide-overflow">
            <Profile v-on:changeProvincia="changeProvincia" :option="bottomNav" :provinciaSelect="provinciaSelect" :municipioSelect="municipioSelect" :provinciaUser="provinciaUser" :user="usuario" :userSelected="userSelected" :uid="uid" :userDocuments="userDocuments" />
        </v-card> -->
    <v-snackbar
      v-model="expedienteProfile.hasSaved"
      :timeout="2000"
      absolute
      bottom
      left
    >
      Datos actualizados en el Servidor
    </v-snackbar>
    <div class="loading" v-if="guardando"></div>
  </div>
</template>

<script>
// import Profile from "./profile";
import NewExpediente from "./expedientes-new";

export default {
  name: "Expedientes",
  // props: ['uid'],
  components: {
    // Profile,
    NewExpediente
  },
  data() {
    return {
      config: {
        desactivar: "Desactivado"
      },
      newExpedienteDialog: false,
      bottomNav: 0,
      usuario: {},
      // users: [],
      usersControl: {
        headers: [
          { text: "#", align: "left", value: "idx", sortable: true },
          { text: "Nombre", align: "left", value: "nombre", sortable: true },
          {
            text: "Apellidos",
            align: "left",
            value: "apellidos",
            sortable: true
          },
          { text: "Email", align: "left", value: "email", sortable: true },
          { text: "Tlf", align: "left", value: "tlf", sortable: true },
          { text: "Rol", align: "left", value: "rol", sortable: true },
          { text: "Accion", align: "right", value: "name", sortable: false }
        ]
      },
      usersFilteredList: true,
      usersFilterOption: {
        rol: []
      },
      userSelected: false,
      userAsignar: false,
      userSearchFor: false,
      searchUser: "",
      usersDialog: false,
      userEditActive: false,
      expteFilteredDialog: false,
      expteFilteredList: true,
      expedientesFilterOption: {
        provincia: [],
        gestor: [],
        admon: [],
        status: []
      },
      // expedientes: [],
      // expteStatus:[],
      expedienteSelected: false,
      catastroSelected: false,
      catastroFilteredList: true,
      catastroFilterOption: {
        uso: [],
        propietario: []
      },
      catastroControl: {
        headers: [
          { text: "#", align: "center", value: "car", sortable: true },
          {
            text: "BL",
            align: "center",
            value: "dir_int_bloque",
            sortable: true
          },
          {
            text: "ESC",
            align: "center",
            value: "dir_int_escalera",
            sortable: true
          },
          {
            text: "PLTA",
            align: "center",
            value: "dir_int_planta",
            sortable: true
          },
          {
            text: "PUERTA",
            align: "center",
            value: "dir_int_puerta",
            sortable: true
          },
          { text: "%", align: "right", value: "participacion", sortable: true },
          {
            text: "Popietario",
            align: "center",
            value: "propietario",
            sortable: true
          }
        ],
        headersPre: [
          { text: "#", align: "center", value: "car", sortable: true },
          {
            text: "BL/ESC/PLTA/PUERTA",
            align: "center",
            value: "",
            sortable: false
          },
          {
            text: "Pre-Registro",
            align: "center",
            value: "preUserName",
            sortable: true
          },
          { text: "Tlf", align: "center", value: "telefono", sortable: true },
          { text: "Acción", align: "center", value: "", sortable: false }
        ],
        tableOption: 0,
        fichaOptions: {
          rowsPerPageItems: [4, 8, 12],
          pagination: {
            rowsPerPage: 4
          }
        }
      },
      searchExpediente: "",
      expedientesControl: {
        headers: [
          { text: "#", align: "left", value: "idx", sortable: true },
          {
            text: "Provincia",
            align: "left",
            value: "detalle.provincia",
            sortable: true
          },
          {
            text: "Gestor",
            align: "left",
            value: "detalle.gestor",
            sortable: true
          },
          {
            text: "Fecha",
            align: "left",
            value: "detalle.fecha",
            sortable: true
          },
          {
            text: "Administrador",
            align: "left",
            value: "detalle.admon",
            sortable: true
          },
          {
            text: "Estado",
            align: "left",
            value: "detalle.status",
            sortable: true
          },
          {
            text: "Editar",
            align: "right",
            value: "name",
            sortable: false
          } /* ,
                    { text: 'Borrar', align: 'right', value: 'name', sortable: false } */
        ]
      },
      expedienteProfile: {
        hasSaved: false,
        isEditing: null,
        model: null
      },
      searchCatastro: "",
      enabledSearchCatastro: false,
      searchingCatastro: "",
      expteRules: {
        valid: true,
        name: "recipient",
        catastroRules: [
          v => !!v || "Referencia catastral requerida",
          v =>
            (v && v.length <= 20 && v.length > 13) ||
            "Debe contener entre 14 y 20 caracteres"
        ]
      },
      provinciaExpediente: null,
      municipioExpediente: null,
      isLoginVerified: false,
      identityError: false,
      title: "Gestión Documentos",
      isLoged: true,
      isErrLoged: false,
      ready: true,
      guardando: false,
      provisionalDocuments: false,
      userDocuments: [],
      usuarioBase: {
        nombre: "",
        apellidos: null,
        nif: null,
        tlf: [],
        direccion: {
          calle: null,
          localidad: null,
          provincia: null
        },
        refCatastro: null,
        notas: ""
      },
      originalUser: {},
      /* municipioSelect: [],
            municipios: [
                {
                    text: 'Seleccionar',
                    value: null
                }
            ], */
      // provinciaSelect: [],
      /* provincias: [
                {
                    text: 'Seleccionar',
                    value: null
                }
            ], */
      provinciaUser: null //,
      //usersPreReg: {}
    };
  },
  watch: {
    searchCatastro(ahora) {
      this.searchingCatastro = "";
      if (ahora !== "") {
        let length = ahora.length;
        if (length === 14) {
          // consoleLog(`Buscar Catastro: ${ahora}`)
          this.searchingCatastro = `...buscando ${ahora}`;
          this.getResultCatastro();
        }
      }
    },
    bottomNav(ahora) {
      if (ahora === 0) {
        this.userEditActive = false;
        this.userSelected = false;
        this.expedienteSelected = false;
        this.catastroSelected = false;
        this.catastroControl.tableOption = 0;
        this.catastroFilteredList = true;
        this.catastroFilterOption.uso = [];
        this.catastroFilterOption.propietario = [];
      }
      if (ahora === 1) {
        this.userEditActive = false;
        this.userSelected = false;
      }
      if (ahora === 2) {
        if (this.usuario.direccion.provincia) {
          this.cargaPueblos(this.usuario.direccion.provincia);
        }
      }
    },
    /* provinciaUser(newProvincia, oldProvincia) {
            this.usuario.direccion.provincia = newProvincia
            // Si es un cambio manual inicializa la localidad del usuario
            if (oldProvincia !== null) {
                this.usuario.direccion.localidad = null
            }
            this.cargaPueblos(newProvincia)
        }, */
    provinciaExpediente(newProvincia) {
      this.cargaPueblos(newProvincia);
    }
  },
  created() {
    // Object.assign(this.originalUser, this.usuario)
    /* this.setUsers()
        this.setUsersPreReg()
        this.setExpedientes()
        this.setCatastro()
        this.setProvincias()
        this.setExpedientesStatus() */
  },
  mounted: function() {
    // this.userLoged()
    this.$emit("changeBottomNav", 0);
  },
  methods: {
    prueba() {
      // Esto es una prueba
    },
    /* setUsers() {
            this.$store.dispatch('setUsers');
        },
        setUsersPreReg() {
            this.$store.dispatch('setUsersPreReg');
        },
        setExpedientes() {
            this.$store.dispatch('setExpedientes');
        },
        setExpedientesStatus() {
            this.$store.dispatch('setExpedientesStatus');
        },
        setCatastro() {
            this.$store.dispatch('setCatastro');
        }, */
    setMunicipios(data) {
      this.$store.dispatch("setMunicipios", data);
    },
    /* setProvincias() {
            this.$store.dispatch('setProvincias');
        }, */
    updateExpedientes(data) {
      this.$store.dispatch("updateExpedientes", data);
    },
    preUserNew(item) {
      // eslint-disable-next-line
            // console.log('Actualizado el index: ',index)
      const tlf = item.preUserTlf;
      // const nombre = item.preUserName
      let nombre = item.preUserName;
      if (nombre.length < 2) {
        return alert(`El Nombre introducido no es correcto ${nombre}`);
      }
      const patronTlf = /^[6][0-9]{8}$/;
      if (!patronTlf.test(tlf)) {
        return alert(`El teléfono introducido no es correcto ${tlf}`);
      }
      nombre = nombre
        .toLowerCase()
        .split(" ")
        .map(s => s.charAt(0).toUpperCase() + s.substring(1))
        .join(" ");
      const result = {
        expte: this.expedienteSelected.idx,
        ref: this.expedienteSelected.detalle.refCatastro,
        inmu: item.car,
        nombre: nombre,
        tlf: tlf
      };
      // 1 - Comprobar que el número de tlf no existe previamente en la bbdd
      if (this.usersPreReg[tlf]) {
        return alert(
          `Este teléfono ya se encuentra registrado en la base de datos`
        );
      }
      // 2 - Guardar el pre-user
      let objeto = {
        expediente: this.expedienteSelected.idx,
        ref: this.expedienteSelected.detalle.refCatastro,
        inmueble: item.car,
        preUserTlf: tlf
      };
      const encBtoA = window.btoa(JSON.stringify(objeto));
      const url = "https://usuarios.gestionayudas.es/register/phone/?token=";
      const token = `${url}${encBtoA}`;
      objeto.preUserName = nombre;
      objeto.token = token;
      this.$dbFB
        .ref("usersPrereg")
        .child(tlf)
        .set(objeto);
      // 3 - Actualizar el registro en catastro/inmueble
      this.$dbFB
        .ref("catastro")
        .child(result.ref)
        .child("inmuebles")
        .child(item.car)
        .update({
          preUserName: nombre,
          preUserTlf: tlf,
          preUserToken: token,
          preUserSaved: true
        });

      const index = this.catastroSelected.inmuebles.findIndex(
        caso => caso.car === item.car
      );
      // Enviar wathsapp
      let message = encodeURIComponent(`Hola ${nombre},
            Le escribimos desde gestionayudas.es, en virtud de acuerdo suscrito con su Comunidad de Propietarios, en relación a la tramitación de las subvenciones que estamos gestionando para usted y para su Comunidad de Propietarios.
            Para poder continuar con nuestro trabajo, necesitamos que acceda a nuestro sitio web y siga las instrucciones para realizar el proceso de alta y toma de datos.
            Por favor, haga click en el siguiente enlace para acceder:
            ${token}`);
      const lnk =
        "https://api.whatsapp.com/send?text=" +
        message +
        "&phone=" +
        encodeURIComponent(`34${tlf}`);

      this.$nextTick(() => {
        this.catastroSelected.inmuebles[index].preUserSaved = true;
        this.catastroSelected.inmuebles[index].preUserName =
          item.preUserName + " ";
        // Abre aplicación what
        window.open(lnk);
      });
    },
    changeProvincia(newProvincia) {
      this.usuario.direccion.provincia = newProvincia;
      this.usuario.direccion.localidad = null;
      this.cargaPueblos(newProvincia);
    },
    expedienteReset() {
      // consoleLog('Cancelar edición expediente')
    },
    userUid2Name(idx) {
      // Recibe el uid de un usuario y devuelve su nombre y apellidos o su email
      let result = false;
      if (this.users) {
        const user = this.users[idx];
        if (user) {
          result = user.admin.email;
          if (user.private) {
            const name = `${user.private.nombre} ${user.private.apellidos}`;
            if (name.length > 2) {
              result = name;
            }
          }
        }
      }
      return result;
    },
    formatNumber2Dec(n, d = 0) {
      if (!n) {
        return "-";
      }
      const number =
        typeof n === "string" ? parseFloat(n.replace(",", ".")) : n;
      const operando = Math.pow(10, d);
      return (
        "" + parseFloat(Math.round(number * operando) / operando).toFixed(d)
      );
    },
    removeExpteFilter(item, campo) {
      const idx = this.expedientesFilterOption[campo].indexOf(item);
      this.expedientesFilterOption[campo].splice(idx, 1);
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    creteNewExpediente() {
      // consoleLog(`Crear nuevo expediente por el gestor: ${this.uid}`)
      let d = new Date();
      let dia = `0${d.getUTCDate()}`;
      let mes = `0${d.getMonth() + 1}`;
      let year = d.getFullYear();
      dia = dia.substr(-2, 2);
      mes = mes.substr(-2, 2);
      let dateFormat = `${dia}/${mes}/${year}`;
      let data = {
        creadoPor: this.uid,
        admon: false,
        gestor: this.uid,
        status: "Iniciado",
        fecha: dateFormat,
        timeStamp: new Date().getTime()
      };
      // consoleLog(data)
      // Get a key for a new Post.
      // firebase.database().ref().child('posts').push().key;
      let newExpteKey = this.$dbFB.ref("expedientes").push().key;
      this.updateExpedientes({ idx: newExpteKey, data: data });
      this.editarExpediente(newExpteKey);
      this.expedienteProfile.isEditing = true;
    },
    asignarUserCatastro(refCatastro, car) {
      // consoleLog(`Asignar propietario al inmueble ${refCatastro}-${car}`)
      this.userSearchFor = {
        case: "userAsignCatastro",
        refCatastro: refCatastro,
        car: car
      };
      this.userAsignar = true;
      this.usersFilterOption.rol = ["Usuario"];
      this.usersFilteredList = true;
      this.bottomNav = 3;
    },
    userAsignation(user) {
      // consoleLog(`Asignar el usuario ${user} para ${this.userSearchFor.case}`)
      switch (this.userSearchFor.case) {
        case "userAsignCatastro":
          this.$dbFB
            .ref("catastro")
            .child(this.userSearchFor.refCatastro)
            .child("inmuebles")
            .child(this.userSearchFor.car)
            .child("propietario")
            .set(user);
          this.catastroCarga(this.userSearchFor.refCatastro);
          this.userSearchFor = false;
          this.userAsignar = false;
          this.usersFilterOption.rol = [];
          this.bottomNav = 1;
          break;
        default:
          break;
      }
    },
    expteEditUser(idx, categoria = "user") {
      // consoleLog(`Editar usuario: ${idx} como ${categoria}`)
      if (idx) {
        this.userEdit(idx);
      } else {
        // consoleLog(`Agregar nuevo usuario ${categoria}`)
      }
      return categoria;
    },
    expteId(idx) {
      if (idx) {
        if (idx.length > 10) {
          return `${idx.substr(0, 3)}...${idx.substr(-3, 3)}`;
        }
        return idx;
      }
      return idx;
    },
    clearSearchCatastro() {
      this.searchCatastro = "";
    },
    getResultCatastro() {
      // 1 - Buscar en la Base de datos

      // 2 - Buscar en el catastro
      let curl = "https://"; // Poner la url del API
      let searchUrl = curl + this.searchCatastro;
      this.$http
        .get(searchUrl, { crossdomain: true })
        .then(
          function(response) {
            this.searchingCatastro = "";
            let extraidos = this.extraeCatastroData(response.data);
            if (extraidos !== null) {
              this.catastroSave(extraidos, this.searchCatastro);
            }
          }.bind(this)
        )
        .catch(function(error) {
          return error;
          // consoleLog(error)
        });
    },
    extraeCatastroData(data) {
      // consoleLog(data)
      if (data === null) {
        // consoleLog('Error en la data. No existen datos')
        return null;
      }
      let parser = new DOMParser();
      let doc = parser.parseFromString(data, "application/xml");
      // let control = parseInt(doc.getElementsByTagName('control')[0].textContent.trim())
      let inmuebles = doc.getElementsByTagName("rcdnp");
      let campos = [
        ["car", "car"],
        ["cc1", "cc1"],
        ["cc2", "cc2"],
        ["bq", "dir_int_bloque"],
        ["es", "dir_int_escalera"],
        ["pt", "dir_int_planta"],
        ["pu", "dir_int_puerta"]
      ];
      let camposGlobal = [
        ["cp", "provinciaCode"],
        ["cm", "localidadCode"],
        ["cmc", "localidadCodeDGC"],
        ["np", "dir_provinciaName"],
        ["nm", "dir_localidadName"],
        ["nem", "dir_entidadMenorName"],
        ["cv", "viaCode"],
        ["tv", "dir_viaTipo"],
        ["nv", "dir_viaName"],
        ["pnp", "dir_viaNumber"],
        ["plp", "dir_viaLeter"],
        ["dp", "dir_cp"],
        ["dm", "dir_distrito"]
      ];
      let result = {
        expediente: this.expedienteSelected.idx,
        datos: {},
        inmuebles: []
      };
      for (let index = 0; index < inmuebles.length; index++) {
        const inmueble = inmuebles[index];
        let salida = {};
        for (let i = 0; i < campos.length; i++) {
          const campo = campos[i];
          const element = inmueble.getElementsByTagName(campo[0])[0];
          salida[campo[1]] = element ? element.textContent : "";
        }
        salida.propietario = "";
        if (index === 0) {
          for (let i = 0; i < camposGlobal.length; i++) {
            const campo = camposGlobal[i];
            const element = inmueble.getElementsByTagName(campo[0])[0];
            result.datos[campo[1]] = element ? element.textContent : "";
          }
        }
        result.inmuebles.push(salida);
      }
      // consoleLog(`Control: ${control}`)
      // consoleLog(`Número de inmuebles: ${inmuebles.length}`)
      return result;
    },
    uptdateExpediente() {
      this.guardando = true;
      this.updateExpediente({
        idx: this.expedienteSelected.idx,
        data: this.expedienteSelected.detalle
      });
      let ref = this.expedienteSelected.detalle.refCatastro;
      this.catastroCarga(ref);
      this.save();
      /* this.$dbFB.ref('expedientes').child(this.expedienteSelected.idx).update(this.expedienteSelected.detalle, () => {
                // consoleLog('Usuario Actualizado')
                let ref = this.expedienteSelected.detalle.refCatastro
                this.catastroCarga(ref)
                this.save()
            }) */
    },
    catastroSave(data, ref) {
      const inmuebles = data.inmuebles;
      delete data.inmuebles;
      this.$dbFB
        .ref("catastro")
        .child(ref)
        .set(data);
      const campos = [
        ["luso", "uso"],
        ["sfc", "superficie"],
        ["cpt", "participacion"],
        ["ant", "antiguedad"]
      ];
      const camposCons = [["lcd", "uso"], ["stl", "superficie"]];
      for (let index = 0; index < inmuebles.length; index++) {
        let salida = inmuebles[index];
        const refCatastro = ref + salida.car;
        const curl = "https://"; // definir la url API
        const searchUrl = curl + refCatastro;
        this.$http
          .get(searchUrl, { crossdomain: true })
          .then(
            function(response) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(
                response.data,
                "application/xml"
              );
              // let salida = {}
              for (let i = 0; i < campos.length; i++) {
                const campo = campos[i];
                const element = doc.getElementsByTagName(campo[0])[0];
                salida[campo[1]] = element ? element.textContent : "";
              }
              salida.cons = [];
              const cons = doc.getElementsByTagName("cons");
              for (let c = 0; c < cons.length; c++) {
                const consC = cons[c];
                let salidaCons = {};
                for (let i = 0; i < camposCons.length; i++) {
                  const campoCons = camposCons[i];
                  const elementCons = consC.getElementsByTagName(
                    campoCons[0]
                  )[0];
                  salidaCons[campoCons[1]] = elementCons
                    ? elementCons.textContent
                    : "";
                }
                salida.cons.push(salidaCons);
              }
              this.$dbFB
                .ref("catastro")
                .child(ref)
                .child("inmuebles")
                .child(salida.car)
                .set(salida);
            }.bind(this)
          )
          .catch(function(error) {
            return error;
            // consoleLog(error)
          });
        if (index >= inmuebles.length - 1) {
          this.expedienteSelected.detalle.refCatastro = this.searchCatastro;
          this.expedienteSelected.detalle.provincia =
            data.datos.dir_provinciaName;
          this.uptdateExpediente();
        }
      }
    },
    expedienteSave() {
      // consoleLog('Guardar expediente')
      if (this.expedienteSelected) {
        this.guardando = true;
        const idx = this.expedienteSelected.idx;
        const data = this.expedienteSelected.detalle;
        this.$dbFB
          .ref("expedientes")
          .child(idx)
          .set(data, () => {
            // consoleLog(`Guardado el expediente ${idx}`)
            this.save();
          });
      }
    },
    editarExpediente(idx) {
      // this.$emit('changeBottomNav', 1)
      this.expedienteSelected = this.expedientes.filter(
        expte => expte.idx === idx
      )[0];
      // localStorage._GA_expteSelec = JSON.stringify(this.expedienteSelected)
      let ruta = `/user/gestion/expedientes/edit/${idx}`;
      this.$router.push(ruta);
      /* let refCatastro = this.expedienteSelected.detalle.refCatastro || false
            if (refCatastro) {
                this.catastroCarga(refCatastro)
            }
            this.bottomNav = 1 */
    },
    desactivarExpediente(idx) {
      // consoleLog(`Desactivar el expte: ${idx}`)
      confirm("¿Seguro que quieres eliminar este expediente")
        ? this.$dbFB
            .ref("expedientes")
            .child(idx)
            .child("status")
            .set(this.config.desactivar)
        : false; //consoleLog('Contestó NO')
    },
    catastroCarga(refCatastro) {
      // consoleLog(`Referencia Catastro: ${refCatastro}`)
      this.$dbFB
        .ref("catastro")
        .child(refCatastro)
        .once("value")
        .then(snapshot => {
          let val = snapshot.val();
          const inmuebles = val.inmuebles;
          if (Array.isArray(inmuebles)) {
            // Eliminar cuando terminen las pruebas
            this.catastroSelected = snapshot.val();
          } else {
            // versión definitiva
            // delete val.inmuebles
            let inmu = [];
            Object.keys(inmuebles).forEach(key => {
              let doc = inmuebles[key];
              if (!doc.preUserName && !doc.propietario) {
                (doc.preUserName = ""), (doc.preUserTlf = "");
              }
              inmu.push(doc);
            });
            val.inmuebles = inmu;
            this.catastroSelected = val;
          }
        })
        .catch(error => {
          // consoleLog(error)
          return error;
        });
    },
    direccionCatastro(data) {
      let result = false;
      if (data) {
        result = {
          direc1: `${data.dir_viaTipo} ${data.dir_viaName}, ${
            data.dir_viaNumber
          } ${data.dir_viaLeter}`.trim(),
          direc2: `${data.dir_cp} - ${data.dir_localidadName}, ${
            data.dir_provinciaName
          }`
        };
      }
      return result;
    },
    documentListCompos(objeto) {
      this.userDocuments = [];
      Object.keys(objeto).forEach(key => {
        let doc = objeto[key];
        this.userDocuments.push({
          description: doc.description,
          url: doc.url,
          idx: key,
          name: doc.name
        });
      });
    },
    /* expedientesListCompos(objeto){
            this.expedientes = []
            Object.keys(objeto).forEach(key => {
                let doc = objeto[key]
                if (doc.status !== this.config.desactivar) {
                    this.expedientes.push({
                        detalle: doc,
                        idx: key
                    })
                }
            })
        }, */
    save() {
      this.userProfile.isEditing = false;
      this.userProfile.hasSaved = true;
      this.expedienteProfile.isEditing = false;
      this.expedienteProfile.hasSaved = true;
      this.guardando = false;
      this.closeDocument();
    },
    userLoged() {
      // this.cargarDatosAdmin()
      this.isLoged = true;
      this.identityError = false;
      this.ready = true;
      /* let _uid = this.uid
            this.$dbFB.ref('users').child(_uid).child('lastConnect').set(new Date().getTime(), function (error) {
                if (error) {
                    this.identityError = true
                    // this.login() NOTIFICAR A Home.vue (padre)
                } else {
                    this.cargarDatosAdmin()
                    this.isLoged = true
                    this.identityError = false
                    this.ready = true
                }
            }.bind(this)) */
    },
    userEdit(_uid) {
      Object.assign(this.usuario, this.usuarioBase);
      this.userEditActive = true;
      this.userSelected = _uid;
      const data = this.users[_uid];
      if (data.private) {
        Object.assign(this.usuario, data.private);
        this.provinciaUser = this.usuario.direccion.provincia;
      }
      this.usuario.admin = data.admin;
      if (data.documents) {
        this.provisionalDocuments = false;
        this.documentListCompos(data.documents);
      }
      /* Object.assign(this.originalUser, this.usuario)
            if (this.usuario.nombre === '') {
                this.userProfile.isEditing = true
            } */
      // this.cargarProvincias()
      this.bottomNav = 2;
    },
    cargaPueblos(buscar) {
      if (buscar !== null && typeof buscar === "string") {
        this.setMunicipios(buscar);
      }
    },
    userSave() {
      this.guardando = true;
      const userUid = this.userSelected;
      let user = {};
      Object.assign(user, this.usuario);
      delete user.admin;
      if (userUid) {
        this.$dbFB
          .ref("users")
          .child(userUid)
          .child("private")
          .update(user, () => {
            this.save();
          });
      }
    }
  },
  computed: {
    municipioSelect() {
      return this.$store.getters.getMunicipiosSelect;
    },
    provinciaSelect() {
      return this.$store.getters.getProvinciasSelect;
    },
    users() {
      return this.$store.getters.getUsers;
    },
    usersPreReg() {
      return this.$store.getters.getUsersPreReg;
    },
    expteStatus() {
      return this.$store.getters.getExpedientesStatus;
    },
    expedientes() {
      return this.$store.getters.getExpedientesActivos;
    },
    uid() {
      return this.$store.getters.getUserUid;
    },
    usersFilterd() {
      let result = this.usuariosList;
      if (this.usersFilteredList) {
        if (this.usersFilterOption.rol.length > 0) {
          result = result.filter(
            item => this.usersFilterOption.rol.indexOf(item.rol) > -1
          );
        }
      }
      return result;
    },
    usersFiltersRol() {
      if (this.usuariosList) {
        return this.usuariosList.map(item => item.rol).filter(this.onlyUnique);
      }
      return ["Sin resultados"];
    },
    usersArray() {
      return this.$store.getters.getUsersArray;
    },
    adminfincasObject() {
      return this.$store.getters.getAdminFincasObject;
    },
    adminfincas() {
      return this.$store.getters.getAdminFincas; // getAdminFincas
    },
    gestoresObject() {
      return this.$store.getters.getGestoresObject;
    },
    gestores() {
      return this.$store.getters.getGestores;
    },
    catastroFilter() {
      let result = this.catastroSelected ? this.catastroSelected.inmuebles : [];
      const uso = this.catastroFilterOption.uso;
      const propietario = this.catastroFilterOption.propietario;
      if (this.catastroFilteredList) {
        if (result.length > 0 && uso.length > 0) {
          result = result.filter(item => uso.indexOf(item.uso) > -1);
        }
        if (result.length > 0 && propietario.length > 0) {
          const propi = propietario.map(item =>
            item.id ? item.id : "Sin Asignar"
          );
          result = result.filter(
            item =>
              (item.propietario === "" && propi.indexOf("Sin Asignar") > -1) ||
              propi.indexOf(item.propietario) > -1
          );
        }
      }
      return result;
    },
    catastroFilterPre() {
      // pre-registrar usuario
      let result = this.catastroSelected ? this.catastroSelected.inmuebles : [];
      result = result.filter(item => item.propietario === "");
      const uso = this.catastroFilterOption.uso;
      // const propietario = this.catastroControl.tableOption === 1 ? [{id:false}] : this.catastroFilterOption.propietario
      if (this.catastroFilteredList) {
        if (result.length > 0 && uso.length > 0) {
          result = result.filter(item => uso.indexOf(item.uso) > -1);
        }
        // if (result.length > 0 && propietario.length > 0) {
        // const propi = propietario.map(item => item.id ? item.id : 'Sin Asignar')
        // result = result.filter(item => (item.propietario === '' && propi.indexOf('Sin Asignar') > -1) || propi.indexOf(item.propietario) > -1)
        // }
      }
      return result;
    },
    inmueblesFiltersUso() {
      if (this.catastroSelected) {
        return this.catastroSelected.inmuebles
          .map(item => item.uso)
          .filter(this.onlyUnique);
      }
      return ["Sin resultados"];
    },
    inmueblesFiltersPropietarioNamed() {
      return this.inmueblesFiltersPropietario.map(item => {
        return {
          id: item !== "Sin Asignar" ? item : false,
          name: item !== "Sin Asignar" ? this.userUid2Name(item) : "Sin Asignar"
        };
      });
    },
    inmueblesFiltersPropietario() {
      if (this.catastroSelected) {
        const result = ["Sin Asignar"];
        const filter = this.catastroSelected.inmuebles
          .map(item => item.propietario)
          .filter(item => item.length > 0)
          .filter(this.onlyUnique);
        const salida = result.concat(filter);
        return salida;
      }
      return ["Sin resultados"];
    },
    expedientesFiltersAplicados() {
      let result = this.expedientesFilterOption.provincia.slice();
      result = result.concat(this.expedientesFilterOption.gestor.slice());
      result = result.concat(this.expedientesFilterOption.admon.slice());
      result = result.concat(this.expedientesFilterOption.status.slice());
      return this.expteFilteredList ? result : [];
    },
    expedientesFilterProvincias() {
      return this.expedientes
        .map(item => item.detalle.provincia)
        .filter(this.onlyUnique);
    },
    expedientesFilterGestor() {
      return this.expedientes
        .map(item => this.gestoresObject[item.detalle.gestor] || "Sin Gestor")
        .filter(this.onlyUnique);
    },
    expedientesFilterAdmon() {
      return this.expedientes
        .map(
          item =>
            this.adminfincasObject[item.detalle.admon] || "Sin Administrador"
        )
        .filter(this.onlyUnique);
    },
    expedientesFilterStatus() {
      return this.expedientes
        .map(item => item.detalle.status)
        .filter(this.onlyUnique);
    },
    expedientesFilter() {
      let result = this.expedientes;
      let provincias = this.expedientesFilterOption.provincia;
      let gestores = this.expedientesFilterOption.gestor;
      let admones = this.expedientesFilterOption.admon;
      let status = this.expedientesFilterOption.status;
      if (this.expteFilteredList) {
        if (provincias.length > 0) {
          result = result.filter(
            item => provincias.indexOf(item.detalle.provincia) > -1
          );
        }
        if (gestores.length > 0) {
          result = result.filter(
            item =>
              (!item.detalle.gestor && gestores.indexOf("Sin Gestor") > -1) ||
              gestores.indexOf(this.gestoresObject[item.detalle.gestor]) > -1
          );
        }
        if (admones.length > 0) {
          result = result.filter(
            item =>
              (!item.detalle.admon &&
                admones.indexOf("Sin Administrador") > -1) ||
              admones.indexOf(this.adminfincasObject[item.detalle.admon]) > -1
          );
        }
        if (status.length > 0) {
          result = result.filter(
            item => status.indexOf(item.detalle.status) > -1
          );
        }
      }
      return result;
    },
    usuariosList() {
      return this.$store.getters.getUsersList;
    },
    userChange() {
      return this.usuario.notas === this.originalUser.notas;
    },
    color() {
      switch (this.bottomNav) {
        case 0:
          return "blue lighten-1";
        case 1:
          return "teal";
        case 2:
          return "brown";
        case 3:
          return "red";
        case 4:
          return "blue-grey";
        default:
          return "green";
      }
    }
  }
};
</script>
